import { Card } from '@optools/components/ui/card';
import { Skeleton } from '@optools/components/ui/skeleton';

import { EmptyState } from './empty-state';

export interface PoliciesCardProps {
  loading: boolean;
  policies: string[];
}

export function PoliciesCard({ loading, policies }: PoliciesCardProps) {
  return (
    <Card className="flex flex-col overflow-hidden p-4">
      <h2 className="mb-4 text-xl font-semibold">Policies</h2>
      {loading ? (
        <Skeleton className="flex-1" data-testid="policies-skeleton" />
      ) : policies.length > 0 ? (
        <ul className="flex-1 animate-fade-in overflow-auto">
          {policies
            .toSorted((a, b) => a.localeCompare(b))
            .map((policy: string) => (
              <li key={policy} className="border-b py-2 text-sm last-of-type:border-0">
                {policy}
              </li>
            ))}
        </ul>
      ) : (
        <EmptyState message="No policies were attached" />
      )}
    </Card>
  );
}
